module.exports = __webpack_public_path__ + "static/media/kudos-heart-inactive.cd52bb8a.svg";